<template>

  <t-page>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage" :breadcrumb="breadcrumb">



      <template #search>
        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle" :to="currentPage.name + '-form-new'"
                  primary/>
        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form" />
      </template>

      <b-table hover :items="request.content" v-if="checkViewListTableDefault()" :busy="!pageListIsLoaded"
               :fields="fields">

        <template #cell(first)="{item}">
          <t-list-link-primary :label="item.name" :userAuth="userAuth" :id="item.sellerId"
                               :path="currentPage.path"/>
        </template>

        <template #cell(status)="{item}">
          {{ item.status | statusLabel }}
        </template>

        <template #cell(userId)="{item}">
          {{ item.userId > 0 | yesOrNot }}
        </template>

        <template #cell(actions)="{item}">
          <t-list-actions-default :form-path="currentPage.path" :id="item.sellerId" :userAuth="userAuth"/>
        </template>

      </b-table>

      <t-msg v-else warning>{{ t('no-record-found') }}</t-msg>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'Seller',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      fields: [
        {
          key: "first",
          label: "Vendedor"
        },
        {
          key: "userId",
          label: "Possui Acesso"
        },
        {
          key: "note",
          label: "Observação"
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "actions",
          label: ""
        },
      ],


    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      this.breadcrumb = [{text: 'Configurações', to: {name: 'business-setting'}},
      ]

    }

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
